
import {Subject, BehaviorSubject} from 'rxjs';
import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SwitchBoard {
  onLoadingWheel: Subject<any>;
  onNewToast: Subject<any>;
  onLogOut: Subject<any>;
  onLogin: Subject<any>;
  onWallTpiqSwitch: Subject<any>;
  onLogosReady: Subject<any>;
  onUserAccess: Subject<any>;
  onPageChange: Subject<any>;
  onOffCanvasMenuExpand: Subject<any>;
  onShowLargeSidebar: Subject<any>;
  onToastConfirm: Subject<any>;
  onUserOnboard: Subject<any>;
  onCustomerLogin: Subject<any>;
  onBillingDetailsApproved: Subject<any>;
  onSideBarExpand: Subject<any>;
  onTpFirmSideBarWidthChange: Subject<any>;
  toggleAdvanceSearch: Subject<any>;
  onToggleFeedback: Subject<any>;
  onClickPrev: Subject<any>;
  onThemeChange: Subject<any>;
  onPostTabsChange: Subject<any>;
  onDisplayFloatingWindow: Subject<any>;
  onSetPopupTitle: Subject<any>;
  closeAllTabs: Subject<any>;
  onHeaderOptionClicked: Subject<any>;
  onPageChangeListener: Subject<any>;
  onClientLabelsAdvSearch: Subject<any>;
  onSearchLabelDelete: Subject<any>;
  onClientPlansAdvSearch: Subject<any>;
  onClearMenuFilter: Subject<any>;
  onSearchTagDelete: Subject<any>;
  onStrategyTagsAdvSearch: Subject<any>;
  onTaxPlanningStrategyAction: Subject<any>;
  onTaxPlanningClientAction: Subject<any>;
  onRecalculateCustomRates: Subject<any>;
  onUpdateCustomRate: Subject<any>;
  onClearSearch: Subject<any>;
  onTaskCreated: Subject<any>;
  onEditedTask: Subject<any>;
  onTasksSearch: Subject<any>;
  onTasksAdvSearch: Subject<any>;
  onEditTaskAttachments: Subject<any>;
  onRevealClose: Subject<any>;
  onRefreshTrackerPage: Subject<any>;
  onUpdateStatusToDo: Subject<any>;
  onWallSideBarChange: Subject<any>;
  onSidebarChange: Subject<any>;
  onReconnect: Subject<any>;
  onTab: Subject<any>;
  onLoginByToken: BehaviorSubject<boolean>;
  onMailPostCreate: Subject<any>;
  onCreatePost: Subject<any>;
  onPostAction: Subject<any>;
  onqmailAction: Subject<any>;

  constructor() {
    this.onLoadingWheel = new Subject<any>();
    this.onNewToast = new Subject<any>();
    this.onLogOut = new Subject<any>();
    this.onLogin = new Subject<any>();
    this.onWallTpiqSwitch = new Subject<any>();
    this.onLogosReady = new Subject<any>();
    this.onUserAccess = new Subject<any>();
    this.onPageChange = new Subject<any>();
    this.onOffCanvasMenuExpand = new Subject<any>();
    this.onShowLargeSidebar = new Subject<any>();
    this.onToastConfirm = new Subject<any>();
    this.onUserOnboard = new Subject<any>();
    this.onCustomerLogin = new Subject<any>();
    this.onBillingDetailsApproved = new Subject<any>();
    this.onSideBarExpand = new Subject<any>();
    this.onTpFirmSideBarWidthChange = new Subject<any>();
    this.toggleAdvanceSearch = new Subject<any>();
    this.onToggleFeedback = new Subject<any>();
    this.onClickPrev = new Subject<any>();
    this.onThemeChange = new Subject<any>();
    this.onPostTabsChange = new Subject<any>();
    this.onDisplayFloatingWindow = new Subject<any>();
    this.onSetPopupTitle = new Subject<any>();
    this.closeAllTabs = new Subject<any>();
    this.onHeaderOptionClicked = new Subject<any>();
    this.onPageChangeListener = new Subject<any>();
    this.onClientLabelsAdvSearch = new Subject<any>();
    this.onSearchLabelDelete = new Subject<any>();
    this.onClientPlansAdvSearch = new Subject<any>();
    this.onClearMenuFilter = new Subject<any>();
    this.onSearchTagDelete = new Subject<any>();
    this.onStrategyTagsAdvSearch = new Subject<any>();
    this.onTaxPlanningStrategyAction = new Subject<any>();
    this.onTaxPlanningClientAction = new Subject<any>();
    this.onRecalculateCustomRates = new Subject<any>();
    this.onUpdateCustomRate = new Subject<any>();
    this.onClearSearch = new Subject<any>();
    this.onTaskCreated = new Subject<any>();
    this.onEditedTask = new Subject<any>();
    this.onTasksSearch = new Subject<any>();
    this.onTasksAdvSearch = new Subject<any>();
    this.onEditTaskAttachments = new Subject<any>();
    this.onRevealClose = new Subject<any>();
    this.onRefreshTrackerPage = new Subject<any>();
    this.onUpdateStatusToDo = new Subject<any>();
    this.onWallSideBarChange = new Subject<any>();
    this.onSidebarChange = new Subject<any>();
    this.onReconnect = new Subject<any>();
    this.onTab = new Subject<any>();
    this.onLoginByToken = new BehaviorSubject<boolean>(false);
    this.onMailPostCreate = new Subject<any>();
    this.onCreatePost = new Subject<any>();
    this.onPostAction = new Subject<any>();
    this.onqmailAction = new Subject<any>();
  }
}
